
import { toast } from "@/hooks/use-toast";

export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

/**
 * Submit contact form data to the server
 * In a real application, this would connect to your backend API
 */
export const submitContactForm = async (data: ContactFormData): Promise<boolean> => {
  try {
    // Validate the form data
    if (!data.name || !data.email || !data.subject || !data.message) {
      toast({
        title: "Missing Information",
        description: "Please fill out all fields in the form.",
        variant: "destructive",
      });
      return false;
    }

    // In a real implementation, you would send this data to your API
    console.log("Submitting contact form to API:", data);
    
    // Simulate network request
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Check if the email contains @ (basic validation)
    if (!data.email.includes('@')) {
      toast({
        title: "Invalid Email",
        description: "Please enter a valid email address.",
        variant: "destructive",
      });
      return false;
    }
    
    // Success case
    toast({
      title: "Message Sent",
      description: "Thank you for your message. We'll get back to you soon!",
      variant: "success",
    });
    
    return true;
  } catch (error) {
    console.error("Error submitting contact form:", error);
    toast({
      title: "Error",
      description: "There was a problem sending your message. Please try again.",
      variant: "destructive",
    });
    return false;
  }
};
